var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-slider", {
    attrs: {
      "is-processing": _vm.isProcessing,
      "scroll-container-classes": "gfu-project-explorer-card-wrapper",
      tags: _vm.tags,
      items: _vm.projectItems,
      "can-load-more-rows": _vm.canLoadMoreRows,
      "slide-gap-classes": "_px-2 _px-3--m",
      "scroll-container-wrapper-classes": "_pos-r _-mx-2 _-mx-3--m",
      "default-tag-key": _vm.defaultTagKey,
      "aria-busy": _vm.isProcessing,
    },
    on: {
      "get-items": _vm.getItems,
      "load-more": _vm.getMoreItems,
      "tag-clicked": _vm.onTagClicked,
      "view-all": _vm.onViewAllClick,
      "scroll-right": _vm.onScrollRight,
      "scroll-left": _vm.onScrollLeft,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "prefix",
          fn: function () {
            return [_vm._t("prefix")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }